import { cn } from "@/utils";

interface SiteLogoProps {
  className?: string;
}

export default function SiteLogo({ className }: SiteLogoProps) {
  return (
    <span className={cn("relative inline-block", className)}>
      <img
        src="/brand/ai2aim-logo.png"
        alt="AI2Aim Logo"
        className="h-full w-full object-contain dark:hidden"
      />
      <img
        src="/brand/ai2aim-logo-dark.png"
        alt="AI2Aim Logo"
        className="absolute inset-0 h-full w-full object-contain hidden dark:block"
      />
    </span>
  );
}
